export default __webpack_public_path__ + "static/media/fdp (3).8a136341.jpeg";